import * as logger from '@owl-nest/logger'

export function convert(
  amount: number,
  sourceCurrency: string,
  targetCurrency: string,
  rates: { [s: string]: number },
  precision = 0,
): number {
  if (sourceCurrency === targetCurrency) return amount

  if (rates === undefined || rates[sourceCurrency] === undefined || rates[targetCurrency] === undefined) {
    logger.warn("[money] Couldn't find currency in provided rates", { rates, sourceCurrency, targetCurrency })
    return amount
  }

  const convertedAmount = (amount / rates[sourceCurrency]) * rates[targetCurrency]
  return parseFloat(convertedAmount.toFixed(precision))
}
